<div class="headerWrapper" [ngClass]="{ arabic: LanguageService.getLanguage() === 'ar' }">
  <header *ngIf="this.loginService.isLoggedIn()"></header>
  <mat-progress-bar mode="indeterminate" *ngIf="builderService.showUpdateProgress"></mat-progress-bar>
  <mat-progress-bar mode="indeterminate" *ngIf="builderService.showBillingProgress"></mat-progress-bar>
</div>
<div id="mainContentWrapper" [ngClass]="{ arabic: LanguageService.getLanguage() === 'ar', tourModeEnabled: builderService.getTour() }" (click)="closeSidebars()">
  <div class="mobile-sidebar-backdrop" [class.visible]="builderService.sidebarOpened" (click)="builderService.sidebarOpened = false; $event.stopPropagation()"></div>
  <sidebar *ngIf="loginService.isLoggedIn() && !builderService.getTour() && (!builderService.isFromGenie() || (builderService.getGenieMode() !== 'design' && builderService.getGenieMode() !== 'orders'))" [class.open]="builderService.sidebarOpened" class="default"></sidebar>
  <div class="main-content-column">
    <app-breadcrumbs></app-breadcrumbs>
    <router-outlet></router-outlet>
  </div>
</div>
<stacks-toastr></stacks-toastr>
